import { render, staticRenderFns } from "./MerchantDetails.vue?vue&type=template&id=46329fae&"
import script from "./MerchantDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports